document.addEventListener("DOMContentLoaded", function() {
      
      // A. Ocultar preloader después de 1.8 segundos
      setTimeout(function() {
        const loader = document.getElementById("loader");
        if (loader) {
          loader.classList.add("hidden");
        }
      }, 1800);

      // B. Toggle menú overlay (Montez Style)
      const hamburgerBtn = document.getElementById("hamburger-btn");
      const navOverlay = document.getElementById("nav-overlay");
      const hamburger = document.querySelector(".hamburger");
      
      if (hamburgerBtn && navOverlay) {
        hamburgerBtn.addEventListener("click", function() {
          hamburger.classList.toggle("active");
          navOverlay.classList.toggle("active");
        });
        
        // Cerrar al hacer clic en los enlaces de la navegación
        navOverlay.querySelectorAll(".overlay-link").forEach(link => {
          link.addEventListener("click", function(e) {
            e.preventDefault();
            const targetId = this.getAttribute("href");
            const targetElement = document.querySelector(targetId);
            
            // Cerrar menú overlay
            hamburger.classList.remove("active");
            navOverlay.classList.remove("active");
            
            // Desplazarse de forma suave
            if (targetElement) {
              const offsetTop = targetElement.offsetTop;
              window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
              });
            }
          });
        });
      }

      // Smooth scroll genérico para anclas
      document.querySelectorAll('.js-scroll-to').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          if (targetId && targetId !== '#') {
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
        });
      });

      // C. Lógica de Intersección Scroll-Driven para cambiar los temas dinámicos
      const sections = document.querySelectorAll("section[data-nav-bg]");
      
      const observerOptions = {
        root: null,
        rootMargin: "-25% 0px -55% 0px", // Dispara cuando la sección está en el centro de la pantalla
        threshold: 0
      };

      function updateTheme(navBg, navText, borderColor) {
        document.documentElement.style.setProperty("--nav-bg", navBg);
        document.documentElement.style.setProperty("--nav-text", navText);
        document.documentElement.style.setProperty("--body-border-color", borderColor);
        
        document.body.classList.remove("theme-light");
        document.body.classList.add("theme-dark");
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const activeSection = entry.target;
            const navBg = activeSection.getAttribute("data-nav-bg");
            const navText = activeSection.getAttribute("data-nav-text");
            const borderColor = activeSection.getAttribute("data-border-color");
            
            updateTheme(navBg, navText, borderColor);
          }
        });
      }, observerOptions);

      sections.forEach(section => observer.observe(section));
      
      // Inicializar colores y tema en la carga inicial (Héroe)
      const firstSection = sections[0];
      updateTheme(
        firstSection.getAttribute("data-nav-bg"),
        firstSection.getAttribute("data-nav-text"),
        firstSection.getAttribute("data-border-color")
      );

      // D. Animaciones de revelado (Desplazamiento y clip-path - estilo Slipknot)
      const animatedElements = document.querySelectorAll([
        ".mdw-reveal-animation",
        ".mdw-reveal-animation-left",
        ".mdw-reveal-animation-right",
        ".mdw-reveal-animation-top",
        ".mdw-reveal-animation-bottom"
      ].join(","));

      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animated");
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: "0px 0px -50px 0px",
        threshold: 0
      });

      animatedElements.forEach(el => revealObserver.observe(el));

      // E. Lógica de Parallax basada en Scroll (Movimiento de capas - estilo Slipknot)
      function handleScrollParallax() {
        const windowHeight = window.innerHeight;
        document.querySelectorAll(".mdw-hs-movement-translate-x, .mdw-hs-movement-translate-y, .mdw-hs-movement-rotate").forEach(el => {
          const rect = el.getBoundingClientRect();
          const elementCenter = rect.top + rect.height / 2;
          const viewportCenter = windowHeight / 2;
          const distanceFromCenter = elementCenter - viewportCenter;
          el.style.setProperty("--parallax", distanceFromCenter);
        });
      }

      window.addEventListener("scroll", handleScrollParallax);
      window.addEventListener("resize", handleScrollParallax);

      // Forzar ejecuciones tras carga y ocultación del loader
      setTimeout(() => {
        handleScrollParallax();
      }, 100);
      
      setTimeout(() => {
        handleScrollParallax();
      }, 1000);

      // F. META PIXEL TRACKING - Eventos lógicos (Spotify, YouTube, Video, Redes)
      document.addEventListener('click', function(e) {
        // Encontrar si el elemento clickeado (o su padre) es un enlace <a>
        const link = e.target.closest('a');
        if (!link) return;
        
        const href = link.getAttribute('href');
        if (!href) return;
        
        // Verificar si existe la función fbq del Pixel
        if (typeof fbq !== 'function') return;

        // 1. Clics en Spotify
        if (href.includes('spotify.com') || href.includes('spoti.fi')) {
          fbq('trackCustom', 'ClickSpotify', { content_name: href });
        }
        
        // 2. Clics en YouTube
        else if (href.includes('youtube.com') || href.includes('youtu.be')) {
          fbq('trackCustom', 'ClickYouTube', { content_name: href });
        }
        
        // 3. Clics en Facebook / Instagram / TikTok
        else if (href.includes('facebook.com') || href.includes('instagram.com') || href.includes('tiktok.com')) {
          fbq('trackCustom', 'ClickSocialMedia', { content_name: href });
        }
        
        // 4. Clic en "Ver Video" (Anchor link a Casa Parlante)
        else if (href === '#live-session') {
          fbq('trackCustom', 'PlayVideo', { content_name: 'Casa Parlante' });
        }
      });

      setTimeout(() => {
        handleScrollParallax();
      }, 2000);

      setTimeout(() => {
        handleScrollParallax();
      }, 2500);

      // Forzar revelado inmediato de los elementos del Teaser/Hero por seguridad
      document.querySelectorAll("#teaser [class*='mdw-reveal-animation']").forEach(el => {
        el.classList.add("animated");
      });

      // ==========================================================
      // F. Lógica del Video Carousel (Estilo Sticky Fingers)
      // ==========================================================
      const videosData = window.ltVideosData || [
        { title: "Cómo Te Sientes", youtubeId: "pwC5_CBwYBs" },
        { title: "Corazón de Sandía", youtubeId: "5rT7iJ-j_0s" },
        { title: "La Medicina", youtubeId: "iB-M-bI6-04" },
        { title: "Tamo Haciéndolo", youtubeId: "hO7gR8qR1cI" },
        { title: "Cha Cha Cha", youtubeId: "1xN5b0f5l0Q" }
      ];

      let currentVideoIndex = 0;
      let isPlaying = false;

      const playerContainer = document.getElementById("carousel-player-container");
      const thumbnailsContainer = document.getElementById("carousel-thumbnails-container");

      function getThumbnailUrl(youtubeId, callback) {
        const maxresUrl = `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
        const hqUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
        
        const img = new Image();
        img.onload = function() {
          if (this.width === 120) {
            // YouTube placeholder si maxresdefault no está disponible
            callback(hqUrl);
          } else {
            callback(maxresUrl);
          }
        };
        img.onerror = function() {
          callback(hqUrl);
        };
        img.src = maxresUrl;
      }

      function renderPlayer() {
        if (!playerContainer) return;
        
        const video = videosData[currentVideoIndex];
        
        if (isPlaying) {
          playerContainer.innerHTML = `
            <iframe src="https://www.youtube-nocookie.com/embed/${video.youtubeId}?autoplay=1&rel=0" 
                    title="Los Tetas - ${video.title}" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen>
            </iframe>
          `;
        } else {
          playerContainer.innerHTML = `
            <div class="carousel-cover" id="carousel-current-cover" onclick="playVideo()">
              <div class="carousel-play-btn"></div>
              <div class="carousel-title-overlay">${video.title}</div>
            </div>
          `;
          
          getThumbnailUrl(video.youtubeId, function(url) {
            const coverEl = document.getElementById("carousel-current-cover");
            if (coverEl) {
              coverEl.style.backgroundImage = `url('${url}')`;
            }
          });
        }
      }

      function renderThumbnails() {
        if (!thumbnailsContainer) return;
        
        thumbnailsContainer.innerHTML = "";
        videosData.forEach((video, index) => {
          const isActive = index === currentVideoIndex;
          const thumbUrl = `https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`;
          
          const card = document.createElement("div");
          card.className = `carousel-thumb-card ${isActive ? 'active' : ''}`;
          card.style.backgroundImage = `url('${thumbUrl}')`;
          card.setAttribute("onclick", `setVideo(${index})`);
          
          card.innerHTML = `
            <div class="carousel-thumb-title">${video.title}</div>
          `;
          
          thumbnailsContainer.appendChild(card);
        });
      }

      window.playVideo = function() {
        isPlaying = true;
        renderPlayer();
      };

      window.setVideo = function(index) {
        if (index === currentVideoIndex) return;
        currentVideoIndex = index;
        isPlaying = false;
        renderPlayer();
        renderThumbnails();
      };

      window.prevVideo = function() {
        let newIndex = currentVideoIndex - 1;
        if (newIndex < 0) {
          newIndex = videosData.length - 1;
        }
        window.setVideo(newIndex);
      };

      window.nextVideo = function() {
        let newIndex = currentVideoIndex + 1;
        if (newIndex >= videosData.length) {
          newIndex = 0;
        }
        window.setVideo(newIndex);
      };

      // Inicializar carousel
      renderPlayer();
      renderThumbnails();

    });
// ==========================================================
// G. Discography Modal Logic
// ==========================================================
document.addEventListener("DOMContentLoaded", function() {
  const discoModal = document.getElementById("disco-modal");
  if (!discoModal) return;
  
  const modalCloseBtn = discoModal.querySelector(".disco-modal-close");
  const modalCover = discoModal.querySelector("#disco-modal-img");
  const modalTitle = discoModal.querySelector("#disco-modal-title");
  const modalDate = discoModal.querySelector("#disco-modal-date");
  const modalSpotify = discoModal.querySelector("#disco-modal-spotify");
  const modalYoutube = discoModal.querySelector("#disco-modal-youtube");
  const modalContent = discoModal.querySelector(".disco-modal-content");

  // Open modal
  window.openDiscoModal = function(element) {
    const title = element.getAttribute("data-title");
    const date = element.getAttribute("data-date");
    const coverUrl = element.getAttribute("data-cover");
    const spotifyUrl = element.getAttribute("data-spotify");
    const youtubeUrl = element.getAttribute("data-youtube");

    modalCover.src = coverUrl;
    modalTitle.textContent = title;
    modalDate.textContent = date ? "Lanzamiento: " + date : "";
    
    if (spotifyUrl) {
      modalSpotify.href = spotifyUrl;
      modalSpotify.style.display = "inline-block";
    } else {
      modalSpotify.style.display = "none";
    }

    if (youtubeUrl) {
      modalYoutube.href = youtubeUrl;
      modalYoutube.style.display = "inline-block";
    } else {
      modalYoutube.style.display = "none";
    }

    discoModal.classList.add("active");
  };

  // Close modal functions
  function closeDiscoModal() {
    discoModal.classList.remove("active");
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener("click", closeDiscoModal);
  }

  // Close when clicking outside modal content
  discoModal.addEventListener("click", function(e) {
    if (!modalContent.contains(e.target)) {
      closeDiscoModal();
    }
  });

  // Close on Escape key
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && discoModal.classList.contains("active")) {
      closeDiscoModal();
    }
  });
});
